const BASE_URL = process.env.COMCATE_API_URL;
export const getSubmissions = (token, contactInfo) => {
    return fetch(`${process.env.COMCATE_API_URL}/crm/${token}/request-user-submission`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json;charset=utf-8'
        },
        body: JSON.stringify({ contactInfo })
    }).then(response => {
        if (response.status >= 200 && response.status <= 299) {
            return response.json();
        }
        else {
            throw Error(response.statusText);
        }
    });
};
